import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Onboarding from 'Containers/onboarding'

export default () => (
  <Switch>
    <Route path="/onboarding" component={Onboarding} />
  </Switch>
)